import { useState, useEffect, useRef } from 'react'

const SearchableDropdown = ({
    value = '',
    options = [],
    onSelect = () => {},
    fetchOptions = async (q) => [],
    placeholder = 'Search...',
    debounceTime = 500,
    disabled = false,
    search,
    setSearch,
}) => {
    // const [options, setOptions] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const wrapperRef = useRef(null)
    const debounceRef = useRef(null)

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        clearTimeout(debounceRef.current)

        debounceRef.current = setTimeout(async () => {
            await fetchOptions(search)
            setLoading(false)
        }, debounceTime)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    const handleSelect = (option) => {
        setSearch(option.name)
        onSelect(option._id)
        setIsOpen(false)
    }

    return (
        <div className="position-relative" ref={wrapperRef}>
            <input
                type="text"
                className="form-control form-control-sm"
                placeholder={placeholder}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onFocus={() => {
                    if (options.length > 0 && !disabled) setIsOpen(true)
                }}
                disabled={disabled}
            />
            {isOpen && (
                <ul
                    className="list-group bg-dark position-absolute w-100 z-index-10"
                    style={{ maxHeight: 200, overflowY: 'auto' }}
                >
                    {loading ? (
                        <li className="list-group-item small text-muted">Loading...</li>
                    ) : options.length > 0 ? (
                        options.map((option) => (
                            <li
                                key={option._id}
                                className="list-group-item list-group-item-action"
                                onClick={() => handleSelect(option)}
                                style={{ cursor: 'pointer' }}
                            >
                                {option.name}
                            </li>
                        ))
                    ) : (
                        <li className="list-group-item small text-muted">No options found</li>
                    )}
                </ul>
            )}
        </div>
    )
}

export default SearchableDropdown
